import { createSelector } from '@reduxjs/toolkit'
import { pathname$ } from '../reducers/browser-info.slice'
import { landingView$, landingRedirect$ } from '../reducers/landing.slice'

// FIXME: Refactor Pair for new login flow
export const hasPairPageStyles$ = /*@__PURE__*/ createSelector(
	landingRedirect$,
	landingView$,
	pathname$,
	(landingRedirect, landingView, pathname) =>
		Boolean(
			pathname.startsWith('/pair') ||
				(landingRedirect?.startsWith('/pair') && pathname === '/' && landingView == 'login'),
		),
)

export const shouldShowFooter$ = /*@__PURE__*/ createSelector(
	pathname$,
	(p) => p != '/' && !['/forgot', '/pair', /*probably!*/ '/reset', '/verify'].includes(p),
)

export const isFullWidthLandingView$ = /*@__PURE__*/ createSelector(
	pathname$,
	(pathname) => pathname === '/',
)

export const isPromoPage$ = /*@__PURE__*/ createSelector(pathname$, (p) => p.startsWith('/promo'))
